(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditWebinarModalCtrl", ["$scope", "$window", "$localStorage", "learningItemWebinarArchivesResource", "learningItemWebinarArchive", "calendarSettingsService", "messageService", learningItemEditWebinarModalCtrl]);
    function learningItemEditWebinarModalCtrl($scope, $window, $localStorage, learningItemWebinarArchivesResource, learningItemWebinarArchive, calendarSettingsService, messageService) {
        var vm = this;
        vm.archive = learningItemWebinarArchive.archive;
        vm.localizationId = learningItemWebinarArchive.localizationId;
        vm.enabledLocalizations = $localStorage.tenantSettings.enabledLocalizations;
        vm.showErrors = false;
        if (vm.archive)
            vm.archive.date = new Date(vm.archive.date);
        vm.format = "yyyy-MM-dd";
        calendarSettingsService.calendarSetup($scope);
        vm.open = calendarSettingsService.openToggle;
        ////Date picker Config
        vm.datePickerList = [];
        vm.goToLink = function (url) {
            if (url) {
                if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1 || url.indexOf("ftp") > -1) {
                    $window.open(url, "_blank");
                }
                else {
                    $window.open("http://" + url, "_blank");
                }
            }
            else {
                vm.showErrors = true;
            }
        };
        vm.saveArchive = function () {
            if (vm.webinarForm.$valid) {
                vm.saving = true;
                if (vm.archive) {
                    if (vm.archive.archiveUrl.indexOf("http://") === -1 && vm.archive.archiveUrl.indexOf("https://") === -1 && vm.archive.archiveUrl.indexOf("ftp") === -1)
                        vm.archive.archiveUrl = "http://" + vm.archive.archiveUrl;
                }
                var learningItemWebinar = {
                    learningItemId: learningItemWebinarArchive.learningItemId,
                    archiveUrl: vm.archive.archiveUrl,
                    localizationId: learningItemWebinarArchive.localizationId,
                    date: vm.archive.date
                };
                if (vm.archive.id) { // For edits,Pass the archive with id
                    learningItemWebinar.id = vm.archive.id;
                    learningItemWebinar.localizationId = vm.archive.localizationId;
                    learningItemWebinarArchivesResource.save({ learningItemId: learningItemWebinar.learningItemId, id: learningItemWebinar.id }, learningItemWebinar, function (result) {
                        if (result.value) {
                            messageService.success("learningItem.updatedSuccessMessage");
                            $scope.$close(learningItemWebinar);
                        }
                        else {
                            messageService.error("common.genericError");
                        }
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else { // for add, there is no existing id
                    learningItemWebinarArchivesResource.save({ learningItemId: learningItemWebinar.learningItemId }, learningItemWebinar, function (result) {
                        learningItemWebinar.id = result.value;
                        messageService.success("learningItem.updatedSuccessMessage");
                        $scope.$close(learningItemWebinar);
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
            }
            else {
                vm.saving = false;
                vm.showErrors = true;
            }
        };
    }
})();
